export const ShipmentCommentContract  = {
    async upload_comments() {
        throw new Error("upload_comments_shipment_comments not implemented");
    }
}